export default __webpack_public_path__ + "static/media/team.58efa1a2.png";